import { PBIExportableReport } from 'managed-analytics/domain/PBIReport';
import { Scheduler, SchedulerLimit } from 'managed-analytics/domain/Scheduler';

export type RawSchedule = {
	uuid?: string;
	subject: string;
	user?: string;
	role: string;
	schedule: string;
	event_config: {
		days: string[];
		times: string[];
		timezone: string;
		exportType?: string;
		report?: PBIExportableReport;
		emails?: string[];
	};
};

export type RawSchedulerLimit = {
	uuid: string;
	name: string;
	description: string;
	max_schedules_per_period: number;
	period_type: 'day' | 'week' | 'month';
	min_interval_minutes: number;
	is_active: boolean;
	is_execution_blocked: boolean;
	created_at: string;
	updated_at: string;
	role: string;
	created_by: string;
};

export const mapApiToSchedule = (raw: RawSchedule): Scheduler => ({
	uuid: raw.uuid,
	name: raw.subject,
	userUuid: raw.user as string,
	roleUuid: raw.role,
	schedule: raw.schedule,
	eventConfig: {
		...raw.event_config,
		report: raw.event_config?.report ?? undefined,
	},
});

export const mapScheduleToApi = (schedule: Scheduler): RawSchedule => {
	const { report, days, times, emails, timezone, exportType } = schedule.eventConfig;

	const apiReport = report
		? {
				groupId: report.groupId,
				reportId: report.reportId,
				roleName: report.roleName,
				roleUuid: report.roleUuid,
				userUuid: report.userUuid,
				datasetId: report.datasetId,
				rlsFilter: (report as any).rlsFilter,
				rlsFilterRoleName: (report as any).rlsFilterRoleName,
				reportName: report.reportName,
				pdfDemoFile: (report as any).pdfDemoFile ?? null,
				pdfDemoFileExpiresAt:
					(report as any).pdfDemoFileExpiresAt
						? new Date((report as any).pdfDemoFileExpiresAt).toISOString()
						: null,
			}
		: undefined;

	// Build body per server spec. Do not send uuid/user on create, server infers user from auth.
	return {
		// uuid omitted on create; if present for update, backend may ignore for POST
		subject: schedule.name,
		role: schedule.roleUuid,
		schedule: schedule.schedule,
		event_config: {
			days,
			times,
			emails,
			timezone,
			exportType,
			report: apiReport as any,
		},
	} as unknown as RawSchedule;
};


export const mapApiToSchedulerLimit = (raw: RawSchedulerLimit): SchedulerLimit => ({
	uuid: raw.uuid,
	name: raw.name,
	description: raw.description,
	max_schedules_per_period: raw.max_schedules_per_period,
	period_type: raw.period_type,
	min_interval_minutes: raw.min_interval_minutes,
	is_active: raw.is_active,
	is_execution_blocked: raw.is_execution_blocked,
	created_at: raw.created_at,
	updated_at: raw.updated_at,
	role: raw.role,
	created_by: raw.created_by,
});